module.exports = __webpack_public_path__ + "static/img/book3.69d36f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book3.jpg
// module id = 0zLD
// module chunks = 1